<!-- AI Generated Template -->
<form class="page-fix-form-skip-to-content-options" #form="ngForm">
    <div class="px-4 py-6">
        <h2 class="mt-0" translate>Repair options</h2>
        <p class="text-bold mb-1" translate>Repair Tip</p>
        <p class="mb-4" translate>
            CSS selectors need to be inserted in a correct format:
            .class-name and #id-name.
            If you wish to add multiple selectors on one line
            make sure the id is always inserted before class and the selectors don't have any spaces or special characters between them.
        </p>
        <div class="row mb-4">
            <div class="col-auto">
                <p class="text-bold mb-1" translate>Example 1</p>
                <p class="example-content mb-0" translate>
                    .class-name1
                </p>
            </div>
            <div class="col-auto">
                <p class="text-bold mb-1" translate>Example 2</p>
                <p class="example-content mb-0" translate>
                    #idname.class-name1.class-name2
                </p>
            </div>
        </div>
        <strong translate class="mb-1 inline-block">Default fix</strong>
        <div class="row mt-1">
            <div class="col-48 col-md-21 pr-md-1">
                <div class="bg-light-grey border-rounded p-4">
                    <label for="skip_to_content_text" translate>
                        Choose your own text for the Skip to Content link button<span class="fas fa-question-circle" aria-hidden="true" [placement]="'top-right'" ngbTooltip="{{ 'Give a title to your Skip to Content button' | translate }}"></span>
                    </label>
                    <div class="row form-group mb-4">
                        <div class="col pr-0">
                            <input type="text"
                                   class="form-control"
                                   required
                                   [(ngModel)]="skipToContentText"
                                   name="contentText"
                                   id="skip_to_content_text">
                        </div>
                        <div class="col-auto pl-0">
                            <button type="button"
                                    class="btn btn-border-radius btn-link btn-reset-text"
                                    (click)="resetText()"
                                    ngbTooltip="{{ 'Reset to default' | translate}}">
                                <span class="sr-only" translate>Reset Skip to content text to its default</span>
                                <span class="fas fa-redo-alt fa-lg" aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <form-field-errors [input]="form.controls['contentText']" offset="0">
                        </form-field-errors>
                    </div>
                </div>
            </div>
            <div class="col-48 col-md-27 pl-md-1">
                <div class="bg-light-grey border-rounded p-4">
                    <p class="inline-block mb-4" translate>Insert the CSS selector targets you want your visitors to land on<span class="fas fa-question-circle"
                        aria-hidden="true"
                        [placement]="'top-right'"
                        ngbTooltip="{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}"></span>
                    </p>
                    <p class="text-secondary-4 mb-1" translate>Insert CSS class or id selector</p>
                    <div class="row form-group mb-1 mt-2" *ngFor="let selector of selectors; let i = index; trackBy: trackByIndex">
                        <div class="col-38 pr-2">
                            <label [attr.for]="'skip_to_content_selector_' + i" class="sr-only" translate>
                                CSS selector
                            </label>
                            <input type="text"
                                   class="form-control"
                                   [(ngModel)]="selectors[i]"
                                   [attr.id]="'skip_to_content_selector_' + i"
                                   [name]="'selector_' + i">
                        </div>
                        <div class="col-auto pl-0">
                            <button type="button"
                                    class="btn btn-border-radius btn-secondary"
                                    (click)="removeSelector(i)"
                                    ngbTooltip="{{ 'Remove row' | translate}}">
                                <span class="sr-only" translate>Remove row</span>
                                <span class="far fa-trash-alt" aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button type="button"
                                    class="btn btn-border-radius btn-secondary"
                                    (click)="addSelector()"
                                    ngbTooltip="{{ 'Add row' | translate}}">
                            <span class="sr-only" translate>
                                Add row
                            </span>
                                <span class="fas fa-plus" aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
